import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FunnelChart3dComponent } from './funnel-chart-3d/funnel-chart-3d.component';

@NgModule({
  declarations: [
    FunnelChart3dComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FunnelChart3dComponent,
  ]
})
export class SharedModule { } 